export default __webpack_public_path__ + "static/media/sabonCeBoldItalic.1f15cee8.ttf";